module.exports = __webpack_public_path__ + "static/media/tipologia18.916d4249.png";